<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="pt02">
<div class="partHead" id="ph02">
<h2 class="partNumber"><span class="bold">II</span></h2>
<div class="partEpigraph">
<p class="partEpigraphText">And he is the guardian of the world, he is the king of the world, he is lord of the universe—and he is myself, thus let it be known, yea, thus let it be known!</p>
<p class="partEpigraphSource"><em class="italic">Kaushitaki-Upanishad,<br/> III Adhyava, 8</em></p>
</div>
</div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_pt02.vue?069d2be5